import {
  useNormalizer,
  useToast,
} from '@sttedra_ui/framework';

// #region ENUMS
import {
  ErrorsMessages,
  SuccessMessages,
} from '@/enum/messages.enum.js';

import {
  ToastTypes,
} from '@/enum/form.enum.js';
// #endregion

const toastService = useToast();

const {
  getBoolean,
  getObjectFilled,
  getArrayFilled,
  getString,
} = useNormalizer();

function manageApiError(response = {}) {
  try {
    if (isSuccess(response)) {
      return response;
    }

    if (getObjectFilled(response) && getArrayFilled(response?.errors)) {
      response.errors.forEach((error) => {
        toastService.add({
          type: ToastTypes.ERROR,
          title: ErrorsMessages.ERROR_UNEXPECTED,
          message: error?.message || ErrorsMessages.ERROR_OPERATION,
          closable: true,
        });
      });
    }

    return false;
  } catch (t) {
    return false;
  }
}

function isSuccess(success) {
  return getBoolean(success) || getString(success) ||
  (getObjectFilled(success) &&
    (success?.status === 200 || success?.status === 204)) || // Object response
  (getObjectFilled(success) && !success.hasOwnProperty('status')) || // Not object response
  (getArrayFilled(success) && success?.length > 0); // Array data response
}

function showSuccessToast(message = null, life = 7000) {
  toastService.add({
    type: ToastTypes.SUCCESS,
    title: SuccessMessages.SUCCESS_OPERATION,
    message: message || SuccessMessages.SUCCESS_OPERATION,
    closable: true,
    life,
  });
}

function showErrorToast(message = null, life = 7000) {
  toastService.add({
    type: ToastTypes.ERROR,
    title: ErrorsMessages.ERROR_UNEXPECTED,
    message: message || ErrorsMessages.ERROR_OPERATION,
    closable: true,
    life,
  });
}

const result = Object.freeze({
  isSuccess,
  manageApiError,
  showErrorToast,
  showSuccessToast,
});

export default function() {
  return result;
}
